import React from 'react';
import PropTypes from 'prop-types';
import DropdownBase from './DropdownBase';

const Dropdown = props => {
  const getStyles = type => {
    switch (type) {
      case 'messaging':
        return {
          textField: {
            maxWidth: '520px',
            backgroundColor: '#F6F6FA',
            width: 150,
          },
          inputRoot: {
            paddingLeft: '7px',
            width: 150,
          },
        };
      case 'cases':
        return {
          root: {
            width: 200,
          },
          textField: {
            maxWidth: '520px',
            backgroundColor: '#F6F6FA',
            width: 200,
          },
          inputRoot: {
            paddingLeft: '7px',
            width: 200,
          },
        };
      case 'filter':
        return {
          root: {
            width: 300,
          },
          textField: {
            maxWidth: '520px',
            backgroundColor: '#F6F6FA',
            width: 300,
          },
          inputRoot: {
            paddingLeft: '7px',
            width: 300,
          },
        };
      default:
        return {};
    }
  };

  const { styleType, ...otherProps } = props;
  const styles = getStyles(styleType);

  return <DropdownBase styles={styles} {...otherProps} />;
};

Dropdown.propTypes = {
  /** Pre-defined custom styles to override DropdownBase */
  styleType: PropTypes.string,
  /** Classname to be applied to <TextField> */
  className: PropTypes.string,
  /** If `true`, the input will not have an underline. */
  disableUnderline: PropTypes.bool,
  /** If `true`, textfield will be in error state */
  hasError: PropTypes.bool,
  /** If `true`, Dropdown will render virtulized */
  virtualized: PropTypes.bool,
  /** Override or extend default styles */
  styles: PropTypes.object,
  /** Name attribute of the `input` element. */
  name: PropTypes.string.isRequired,
  /** Value of `input` element */
  value: PropTypes.any,
  /** Text used for input label */
  label: PropTypes.string,
  /** If `true`, the label is displayed as required. */
  required: PropTypes.any,
  /** Callback fired when value is changed */
  onChange: PropTypes.func,
};

Dropdown.defaultProps = {
  styleType: 'default',
  hasError: false,
  virtualized: false,
  disableUnderline: true,
};

export default Dropdown;
